import Box from "@mui/material/Box"
import CssBaseline from "@mui/material/CssBaseline";
import {PropsWithChildren, useEffect, useState} from "react";

export default (props: PropsWithChildren) => {

    const [image, setImage] = useState("")
    const [attributionName, setAttributionName] = useState("")
    const [attributionUrl, setAttributionUrl] = useState("")
    useEffect(() => {
        fetch("https://api.unsplash.com/photos/random?orientation=landscape&query=manufacturing+metal", {
            headers: {
                "Authorization": "Client-ID kVS_AmL8NSFLg7eSZtYd8U81pZk7pgNuAc6JK3iAWrI"
            }
        })
            .then(response => response.json())
            .then(data => {
                setImage(data.urls.regular)
                setAttributionName(data.user.name)
                setAttributionUrl(data.user.links.html)
            })
    }, [])

    return <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: "url(" + image + ")",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }}>
        <CssBaseline/>
        {props.children}
        <Box sx={{
            position: "fixed",
            bottom: 0, right: 0,
            background: "rgba(122,122,122,0.3)",
            padding: "0.2em",
            fontSize: "0.6em"
        }}>
            Photo by <a style={{color: "black"}}
                        href={attributionUrl + "?utm_source=sadike&utm_medium=referral"}>{attributionName}</a>
            on <a style={{color: "black"}}
                  href={"https://unsplash.com/?utm_source=sadike&utm_medium=referral"}>Unsplash</a>
        </Box>
    </Box>

}
